import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { DoctorVisitSaveModel } from '../entities/doctor-visit';

@Injectable({
  providedIn: 'root'
})
export class CoordinatorDoctorService {

  constructor(private apiService: ApiService) { }

  public GetDoctorList(): Observable<RestResponse> {
    const url = `${API.Coordinator.getCoordinatorDoctorList}`;
    return this.apiService.get(url);
  }

  public GetDoctorVisits(year: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getCoordinatorDoctorVisitList}`;
    url = url.replace('{year}', year);
    return this.apiService.get(url);
  }

  public GetDoctorVisitDetails(id: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getDoctorVisit}`;
    url = url.replace('{id}', id);
    return this.apiService.get(url);
  }

  public AddEditDoctorVisit(doctorVisit: DoctorVisitSaveModel): Observable<RestResponse> {
    const url = `${API.Coordinator.addEditDoctorVisit}`;
    return this.apiService.post(url, doctorVisit);
  }

  public DeleteDoctorVisit(id: string): Observable<RestResponse> {
    let url = `${API.Coordinator.deleteDoctorVisit}`;
    url = url.replace('{id}', id);
    return this.apiService.delete(url);
  }
}
